import React from 'react'

const Bullet = () => {
    return (
        <div className='w-2 h-2 bg-black rounded-full'>

        </div>
    )
}

export default Bullet
